import type { SpotlightRule } from "@follow/shared/spotlight"
import { cn } from "@follow/utils/utils"
import { useMemo, useState } from "react"

import type { RemarkOptions } from "~/lib/parse-markdown"
import { parseMarkdown } from "~/lib/parse-markdown"

import { MarkdownRenderContainerRefContext } from "./context"

export const Markdown: Component<
  {
    children: string
    spotlightRules?: SpotlightRule[]
  } & Partial<RemarkOptions>
> = ({ children, components, className, applyMiddleware, rehypePlugins, spotlightRules }) => {
  const stableRemarkOptions = useMemo(
    () => ({ components, applyMiddleware, rehypePlugins, spotlightRules }),
    [applyMiddleware, components, rehypePlugins, spotlightRules],
  )

  const markdownElement = useMemo(
    () => parseMarkdown(children, { ...stableRemarkOptions }).content,
    [children, stableRemarkOptions],
  )
  const [refElement, setRefElement] = useState<HTMLElement | null>(null)

  return (
    <MarkdownRenderContainerRefContext value={refElement}>
      <article
        className={cn(
          "prose relative cursor-auto select-text dark:prose-invert prose-th:text-left",
          className,
        )}
        ref={setRefElement}
      >
        {markdownElement}
      </article>
    </MarkdownRenderContainerRefContext>
  )
}
